import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SizesService {
  private sizes: string[] = []
  private sizesLower: string[] = []

  setSizes (sizes: string[]): void {
    this.sizes = sizes
    this.sizesLower = sizes.map(s => s.toLowerCase())
  }

  getPage (query: string, first: number, last: number): { items: string[], totalCount: number } {
    const lower = query?.toLowerCase() ?? ''
    const matched = lower ? this.sizes.filter((_, i) => this.sizesLower[i].includes(lower)) : this.sizes
    return {
      items: matched.slice(first, last),
      totalCount: matched.length
    }
  }
}
